export default __webpack_public_path__ + "static/media/nextgen-hcm.95b582c5.png";